import en_lang from 'vuetify/es5/locale/en';

export const en = {
	$vuetify: en_lang,
	buyout: {
		deviceFinder: {
			chose_type: 'Select type',
			chose_brand: 'Select brand',
			chose_model: 'Select model',
			searchDevice: {
				title: 'Find your device',
				text:
					'Please note that the trade-in prices are approximate. You will always find out the final amount at the shop.'
			}
		},
		contractForm: {
			imei_help_text: 'To find the IMEI of your phone, enter *#06#',
			imei: 'Traded-in device IMEI ',
			sn: 'Traded-in device Serial Number (SN) ',
			note: 'Notes',
			pin_or_birth_date: 'Personal identification number / Date of birth',
			identity_card_number: 'ID/ Passport number',
			identity_released_by: 'Issued by',
			identity_valid_to: 'Expiration date',
			degree_before_name: 'Title',
			first_name: 'Name',
			last_name: 'Surname',
			salutation: 'Salutation',
			chose_salutation: 'Select salutation',
			street: 'Address',
			city: 'City',
			country: 'State',
			chose_country: 'Select state',
			postcode: 'Postalcode',
			phone_number: 'Telephone number',
			nationality: 'Nationality',
			place_of_birth: 'Place of birth',
			e_mail: 'E-mail address',
			bank_code: 'Bank code',
			bank_account_full_number: 'Number of the account',
			gender: 'Gender'
		},
		give_registration_number: 'Enter your registration number',
		personal_information: 'Personal data',
		send: 'Send',
		save: 'Save',
		bad_quality:
			'Sorry, this product does not have a defined quality.',
		can_not_be_buyout: 'The trade-in cannot be completed.',
		sell_online: 'Online trade-in',
		send_info_email: 'Send offer to e-mail',
		send_info_email_label:
			'Please enter your e-mail address to which we will send an indicative pricing of the device',
		buyout_price: 'Your trade-in price',
		info_minimal_buyout_price: 'The price after deductions cannot fall below the minimal buyout price',
		find_price_of_device: 'Find out the value of your device',
		detail_pricing: 'Detailed evaluation according to the condition',
		data_for_contract: 'Personal data to conclude the contract',
		search_for_device: 'Find your device',
		continue: 'Continue',
		consent_to_marketing:
			'I give my consent to receive personalised advertising and commercial communications',
		info_price_deduction: 'Price deduction due to non-compliance with standard buyout conditions',
		buying_out: 'Selling out',
		device_condition: 'Device condition',
		category: 'Category',
		deduction: "Deduction",
    surcharge: "Surcharge",
		thankYou: {
			preSale: {
				title:
					'Informative pricing has been sent to your e-mail address under the number <b>{0}</b>.',
				text:
					'If you would like to complete your trade-in stop by one of our stores.'
			},
			onlineBuyout: {
				title: 'Thank you for registering under the number <b>{0}</b>.',
				text: 'Registration confirmation has been sent to your email address.'
			}
		},
		validation: {
			not_null: 'This field should not be blank',
			invalid_email: 'Invalid e-mail'
		},
		deviceSummary: {
			selected_device: 'Selected device',
			bonus: 'Bonus',
			final_price: 'Price quote',
			final_price_w_bonus: 'Total price quote'
		},
		error: {
			common: 'Error in request processing',
			buyout_not_found: 'trade-in was not found. Check the trade-in number.'
		},
		bonus: {
			select_device_for_bonus: 'Select your new device',
			select_your_new_device: 'Select your new {0}',
			select_seller_of_your_new_device: 'Select a dealer for your new {0}'
		},
		partners: {
			partners: 'Partners',
			select_province: 'Select a region',
			for_display_select_province:
				'To view the list of partners, please select a region',
			not_found_in_province: 'No partner found in this region',
			back_to_home: 'Back to home page',
			partners_list: 'List of partners'
		},
		logRegSwapper: {
			login: 'Login',
			log_in: 'Log-in',
			register: 'Register'
		},
		AdditionalInfoForm: {
			reciept: 'Reciept',
			reciept_inserted: 'Receipt uploaded',
			reciept_cant_insert: 'Receipt can no longer be uploaded',
			reciept_upload: 'Upload',
			register_imei_of_new: 'Register IMEI of new {0}',
			register_imei_of_new_global: 'Register IMEI of new device',
			register_sn_of_new_global: 'Register Serial Number (SN) of new device',
			sn_of_new: 'Serial Number (SN) of new device',
			imei_of_new: 'IMEI of new device',
			imei_was_saved: 'New IMEI was saved.',
			sn_was_saved: 'New Serial Number (SN) was saved.',
			edit: 'Edit',
			save: 'Save',
			order_pickup: 'Order collection of my trade-in',
			order: 'Order',
			street: 'Address',
			city: 'City',
			postal: 'Postalcode',
			new_selected_model: 'Model of new device',
			select_new_model_name: 'Select the model of your newly purchased device',
			new_model_was_saved: 'The selected model has been successfully saved',
			new_model_partner_was_saved: 'The selected seller has been successfully saved',
			new_model_partner_main_text: 'Purchased from seller',
			new_model_partner_sub_text: 'Select the seller where the new device was purchased',
			new_model_partner_selector: 'Select seller'
		},
		BuyoutState: {
			buyout_paid: 'The trade-in price has been sent to your registered bank account',
			collection_success: 'Pickup successfully ordered',
			collection_already_ordered: 'Pickup has already been ordered',
			something_went_wrong: 'Something went wrong'
		},
		Revaluation:{
			revaluation_success: 'Suggested revaluation accepted',
			revaluation_denied: 'Suggested revaluation rejected',
			revaluation_closed: 'The trade-in has already been concluded'
		},
	},
	console:{
			all_partners_list: 'List of all partners',
			choose_console_model_accessories_or_game: 'Select your console model, accessories or games',
			detail_pricing_according_to_conditions: 'Detailed evaluation according to the condition',
			accessories_quantity: 'Number of accessories',
			controllers_quantity: 'Number of controllers',
			games_quantity: 'Number of games',
			new_buyout: 'New trade-in',
			how_it_works: 'How it works',
			buyout: 'Trade-in',
			contact: 'Contact',
			new_console: 'New console',
			used_console: 'Used console',
			phone: 'Phone',
			mo_fri: 'Mon - Fri',
			working_hours: 'Working hours',
			information_protection: 'Data protection',
			official_partner: 'Official partner',
			support: 'Support',
			legal_information: 'Legal information',
			informative_pricing: 'Informative pricing',
			personal_information_for_concluding_the_contract:
				'Personal data to conclude the contract',
			buyout_summary:
				'Summary of registration',
			send_the_amount_to_my_account: 'Send money to my account:',
			overall_informative_buyout_price: 'Total price quote',
			i_agree_to_the_processing_of_the_data: 'I agree with the personal data processing.',
			more_information: 'More information',
			here: 'here',
			controllers: 'Controllers',
			games: 'games',
			pieces: 'pcs',
			send: 'Send',
			personal_information: 'Personal data',
			thank_you: 'Thank you, you will receive more information by email',
			continue_to_new_buyout: 'Continue with the new Trade-In',
			games_buyout_not_available: 'Sorry, it is not possible to sell games at the moment.',
			accessories_buyout_not_available: 'Sorry, currently it is not possible to sell the controllers',
			receipt_subtitle: 'Upload a receipt for your new Xbox',
			imei_subtitle: 'Enter the S/N of your new Xbox',
			register_sn_of_new_xbox: 'New Xbox S/N registration',
		},
}
